import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { defer, finalize, Observable } from 'rxjs';
import { HttpActivityService } from '../services/http-activity.service';

export function httpActivityInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const activity = inject(HttpActivityService);
  return defer(() => {
    activity.started();
    return next(req).pipe(finalize(() => activity.finished()));
  });
}
